/* PODbySoni behaviour layer. Loaded from sections/pbs-marquee.liquid, which is
   in header-group and therefore on every page.

   Contents:
     1. Product card colour swatches
     2. Save heart (localStorage)
     3. Sort dropdown width
     4. Free shipping progress bar in the cart drawer - GONE FROM HERE,
        it is Liquid now. See the note where it used to be, below.

   WARNING, learned the hard way: do NOT re-scan the page with a MutationObserver.
   paintHearts writes to the DOM, which is itself a mutation, so the observer
   re-triggers itself and the page locks up hard. Re-init only on explicit events. */
(function () {
  var KEY = 'pbs_saved';

  /* THE HEART IS AN SVG, NOT A CHARACTER. Changed Aug 8, 2026, after Ujjval's
     round 4 note that it looks ugly and gets smaller when you select it.
     It used to swap U+2661 WHITE HEART SUIT for U+2665 BLACK HEART SUIT.
     Those are two different glyphs from two different fonts with different
     advance widths, and the hollow one falls back to a font that draws it
     larger, so selecting it visibly shrank the heart. That is not tunable:
     no font-size makes two different characters the same size.
     One path, drawn once. Selected FILLS the same outline rather than
     replacing it, so the shape cannot move. Filled versus outlined is done in
     CSS from the is-on class, in assets/pbs-ux.css. If that stylesheet is ever
     removed this still renders, just always outlined.
     KEEP THIS ON ONE LINE. Written as three concatenated lines first, and the
     newlines inside the expression did not survive the Admin API write: the
     stored file came back with the second and third joined by a stray
     backslash and the whole script died on a SyntaxError. One line, no plus. */
  var HEART = '<svg class="pbs-heart-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  /* ---------- shared ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* Step 15 (C6): the Saved drawer removes an id through this. Ids are strings. */
  window.pbsSaved = {
    read: read,
    remove: function (id) {
      var l = read();
      var i = l.indexOf(String(id));
      if (i > -1) { l.splice(i, 1); write(l); }
      paintHearts();
    }
  };

  /* ---------- 1 + 2. cards ---------- */
  function paintHearts(root) {
    var saved = read();
    (root || document).querySelectorAll('[data-pbs-heart]').forEach(function (btn) {
      var on = saved.indexOf(btn.dataset.pbsHeart) > -1;
      /* Write the markup once. Repainting on every re-init is what a page-wide
         observer would feed on, and the old version guarded it for that reason. */
      if (!btn.querySelector('.pbs-heart-ico')) btn.innerHTML = HEART;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function initCards(scope) {
    scope.querySelectorAll('[data-pbs-card]').forEach(function (card) {
      if (card.dataset.pbsReady) return;
      card.dataset.pbsReady = '1';

      var main = card.querySelector('[data-pbs-main]');
      if (!main) return;
      var original = main.getAttribute('src');
      var originalSrcset = main.getAttribute('srcset');

      card.querySelectorAll('[data-pbs-sw]').forEach(function (sw) {
        function show(e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          main.removeAttribute('srcset');
          main.src = sw.dataset.pbsSw;
          card.classList.add('is-swatched');
          card.querySelectorAll('[data-pbs-sw]').forEach(function (o) {
            o.classList.toggle('is-on', o === sw);
          });
        }
        sw.addEventListener('mouseenter', function () { show(); });
        sw.addEventListener('click', show);

        /* Warm the colour photo on hover so the very first swap is instant too.
           Same argument as the product page gallery: the image is a fresh
           network fetch the first time its URL is used, and a pointer resting
           on a swatch is a few hundred milliseconds of warning. */
        sw.addEventListener('pointerenter', function () {
          if (sw.dataset.pbsWarm) return;
          sw.dataset.pbsWarm = '1';
          var im = new Image();
          im.decoding = 'async';
          im.src = sw.dataset.pbsSw;
        });
      });

      var shot = card.querySelector('.pbs-card__shot');
      if (shot) {
        shot.addEventListener('mouseleave', function () {
          if (!card.classList.contains('is-swatched')) return;
          card.classList.remove('is-swatched');
          main.src = original;
          if (originalSrcset) main.setAttribute('srcset', originalSrcset);
          card.querySelectorAll('[data-pbs-sw]').forEach(function (o) {
            o.classList.remove('is-on');
          });
        });
      }
    });

    paintHearts(scope);
  }

  /* ---------- 3. sort dropdown ----------
     A native select sizes itself to its WIDEST option, which parked the chevron
     far to the right of a short label like "Best selling". Measure the SELECTED
     label instead and set the width from that. */
  function sizeSort(scope) {
    var sel = scope.querySelector('.facet-filters__sort .select__select, #SortBy');
    if (!sel || !sel.options || !sel.options.length) return;

    var m = document.getElementById('pbs-sort-measure');
    if (!m) {
      m = document.createElement('span');
      m.id = 'pbs-sort-measure';
      m.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:pre;font-size:14px;font-weight:700;letter-spacing:normal';
      m.style.fontFamily = getComputedStyle(sel).fontFamily;
      document.body.appendChild(m);
    }

    m.textContent = sel.options[sel.selectedIndex].text;
    /* 16 left padding + 34 right padding + 4 border */
    sel.style.width = Math.ceil(m.getBoundingClientRect().width + 54) + 'px';
  }

  /* ---------- 4. free shipping progress ----------
     REMOVED FROM JAVASCRIPT, Sep 7 2026. It is server-rendered Liquid now, in
     snippets/cart-drawer.liquid, inside .cart-drawer__footer. The long note
     there is the real explanation; the short version, so nobody rebuilds this:

     shippingBar() did

       var form = document.querySelector('cart-drawer form, #CartDrawer-Form, .cart-drawer__form');
       if (!form) return;

     and then fetched /cart.js and inserted a <div id="pbs-ship-bar"> as the
     form's first child. The selector was fine - #CartDrawer-Form is stock Dawn
     markup and it matched. Two other things killed it:

       a) Dawn re-renders the drawer from the server on every cart change and
          discards the injected node. renderContents() in assets/cart-drawer.js
          sets #CartDrawer.innerHTML on add to cart; updateQuantity() in
          assets/cart.js replaces .drawer__inner innerHTML on a quantity change
          or a line removal; onCartUpdate() in assets/cart.js does
          replaceWith() on cart-drawer-items and .cart-drawer__footer. Add to
          cart is the moment the drawer opens, so the bar was deleted at the
          exact moment it was meant to be read. The only recovery was
          refreshSoon()'s 350ms and 1200ms timers below, racing the same fetch
          that had just destroyed it.

       b) #CartDrawer-Form is display:flex; flex-wrap:wrap (see
          .cart-drawer__form in assets/component-cart-drawer.css), so the bar
          was laid out as a flex ITEM next to the cart items and squeezed
          towards min-content, not as a full-width row above them.

     Liquid has none of those problems: the markup is part of the section Dawn
     re-renders, so it comes back correct on all three routes for free. DO NOT
     add a JS version back alongside it - two renderers is how you get two bars.

     money() went with it; nothing else in this file used it. */

  /* ---------- wiring ---------- */
  function init(root) {
    var scope = root || document;
    initCards(scope);
    sizeSort(scope);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pbs-heart]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.dataset.pbsHeart;
    var saved = read();
    var at = saved.indexOf(id);
    if (at > -1) { saved.splice(at, 1); } else { saved.push(id); }
    write(saved);
    paintHearts();

    /* The pop. Removing the class and forcing a reflow before adding it back is
       what makes the animation restart on the second and every later click; a
       plain add() does nothing when the class is already there. */
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');

    if (window.pbsToast) {
      var on = read().indexOf(id) > -1;
      var phone = window.PBSPhone ? PBSPhone.isPhone() : matchMedia('(max-width: 749px)').matches;
      pbsToast(on ? (phone ? 'Saved' : 'Saved. We will hold it for you.') : 'Removed from saved');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Dawn replaces the grid when filters or sort change, and updates the cart
     drawer on add to cart, without firing an event we can hook. Poll briefly
     after the interactions that cause it rather than watching the whole page. */
  function refreshSoon() {
    setTimeout(function () { init(); }, 350);
    setTimeout(function () { init(); }, 1200);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('facet-filters-form, .facets, #FacetFiltersForm')) refreshSoon();
  });

  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) refreshSoon();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[name="add"], .cart-remove-button, .quantity__button, #cart-icon-bubble')) refreshSoon();
  });

  window.addEventListener('popstate', refreshSoon);
})();